var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_1223_2928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    d: "M2.87382 11.6842H0.458021V4.08159H2.87382V11.6842ZM1.66592 3.0158C0.88434 3.0158 0.315918 2.44737 0.315918 1.6658C0.315918 0.884217 0.955393 0.315796 1.66592 0.315796C2.4475 0.315796 3.01592 0.884217 3.01592 1.6658C3.01592 2.44737 2.4475 3.0158 1.66592 3.0158ZM11.6843 11.6842H9.26855V7.56317C9.26855 6.35527 8.77118 6.00001 8.06065 6.00001C7.35012 6.00001 6.6396 6.56843 6.6396 7.63422V11.6842H4.22381V4.08159H6.4975V5.14738C6.71065 4.65001 7.56328 3.86843 8.77118 3.86843C10.1212 3.86843 11.5422 4.65001 11.5422 6.99474V11.6842H11.6843Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1223_2928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3684,
    height: 11.3684,
    fill: "white",
    transform: "translate(0.315918 0.315796)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.1c69134a5e2fb65ccc9af6eb2e2adcc3.svg";
export { ForwardRef as ReactComponent };